import { withTranslation } from 'react-i18next'
import { Button, Grid } from '@material-ui/core'

import ResumeContents from './ResumeContents'

function Resume({
  classes,
  answers,
  formSelected,
  setIsResume,
  loading,
  handleSubmit,
  t
}) {
  return(
    <Grid
      container
      direction='column'
      alignItems='center'
      alignContent='center'
      spacing={1}
    >
      <ResumeContents 
        classes={classes}
        answers={answers}
        formSelected={formSelected}
      />
      <Grid item className={classes.Buttons} >
        <Button
          variant='outlined'
          color='primary'
          onClick={() => setIsResume(false)}
        >
          {t('cancel')}
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={loading}
          onClick={handleSubmit}
        >
          {t('save_annotation')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default withTranslation()(Resume)